class MobileNavButton extends HTMLButtonElement {
  constructor() {
    super();

    this.addEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const targetAttribute = this.dataset.mobileNavButton;

    event.preventDefault();

    this.classList.toggle("mobile-nav__menu--is-active");

    if (this.nextElementSibling.hasAttribute(targetAttribute)) {
      this.nextElementSibling.classList.toggle("mobile-nav__menu--open");
    }
  }
}

customElements.define("mobile-nav-button", MobileNavButton, {
  extends: "button",
});
